import supabase from '../supabaseClient';

/**
 * Notify Statbox admins that MP4 footage was uploaded for a game.
 * Fire-and-forget — errors are logged but not thrown.
 */
export async function notifyAdminsFootageUploaded({
  matchId,
  source = 'portal',
  uploadToken = null,
} = {}) {
  const trimmedMatchId = String(matchId || '').trim();
  if (!trimmedMatchId) return;

  try {
    const { error } = await supabase.functions.invoke('footage-uploaded-admin-notify', {
      body: {
        matchId: trimmedMatchId,
        source,
        ...(uploadToken ? { uploadToken } : {}),
      },
    });

    if (error) {
      throw error;
    }
  } catch (err) {
    console.error('Failed to notify admins about footage upload:', err);
  }
}
